import { Grid2 as Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { PlusIcon } from 'framework/ui/mui-builder';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  ProjectSectionAccordion,
  StatusFilter,
  useNewProjectUrl,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { EditableListFormShowTemplate, Filters, FiltersLayout } from 'framework/list';
import { useCallback } from 'react';
import ClientTaskList from './ClientTaskList';
import { CLIENT_PORTAL_TASK_STATUS_LABELS, CLIENT_PORTAL_TASK_TYPE_LABELS } from 'domain/shared/clientPortal';
import { ClientPortalUser, ProjectClientPortalData } from '../types';
import { openPageInNewTab } from 'framework/utils';

type ClientTaskSectionProps = {
  projectData: ProjectClientPortalData;
  portalUsers: ClientPortalUser[];
};

const ClientTaskSection = ({ projectData, portalUsers }: ClientTaskSectionProps) => {
  const { isAccessGranted } = useProjectSecurityContext();
  const { getCreateClientPortalTaskUrl } = useNewProjectUrl();

  const filters = (
    <Filters>
      <FiltersLayout>
        <StatusFilter label="Status" source="status" options={CLIENT_PORTAL_TASK_STATUS_LABELS} />
        <StatusFilter label="Type" dropdownLabel="Type" source="type" options={CLIENT_PORTAL_TASK_TYPE_LABELS} />
      </FiltersLayout>
    </Filters>
  );

  const renderActions = useCallback(() => {
    if (isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.MANAGE)) {
      return [
        <IconButton
          sx={{ p: 0, ml: 1 }}
          key="add"
          onClick={() => openPageInNewTab(getCreateClientPortalTaskUrl(projectData?.id!))}
        >
          <PlusIcon />
        </IconButton>,
      ];
    }
    return null;
  }, [isAccessGranted, getCreateClientPortalTaskUrl, projectData?.id]);

  return (
    <EditableListFormShowTemplate
      listSource="tasks"
      localStorageKey={projectData.id ? `project:${projectData.id}:tasks` : undefined}
    >
      <ProjectSectionAccordion
        defaultExpanded
        title={
          <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Grid size={3}>
              <Typography variant="h4" color="primary" pl={2}>
                Client task
              </Typography>
            </Grid>
            <Grid
              size="auto"
              alignItems="center"
              sx={{
                '.add-filter-button__wrapper': { mb: 0 },
                '.filter-item-wrapper': { mb: 0 },
                '.filters-reset-btn': { mb: 0 },
              }}
            >
              {filters}
            </Grid>
            <Grid size="grow" />
            <Grid size="auto">{renderActions()}</Grid>
          </Grid>
        }
      >
        <ClientTaskList clients={portalUsers} />
      </ProjectSectionAccordion>
    </EditableListFormShowTemplate>
  );
};

export default ClientTaskSection;
